import React, { Children, cloneElement } from 'react';

import omit from 'lodash/omit';
import get from 'lodash/get';
import map from 'lodash/map';
import max from 'lodash/max';
import find from 'lodash/find';
import isNil from 'lodash/isNil';

import { SITE_VIEWER_V1 } from 'sites_const_shared/site_viewer_versions.js';

const SITE_VIEWER_VERSION_PROP = 'forSiteViewerVersion';

// `forSiteViewerVersion` is passed as a prop to each child of this component.
// this allows us to define which version the component itself applies to. we
// fallback to the original viewer version since that is the earliest working
// component we can expect.
const getSiteViewerVersionFromChild = (child)=>
  get(child, `props.${SITE_VIEWER_VERSION_PROP}`, SITE_VIEWER_V1);


// attempt to find a matching child for the given siteViewerVersion
const getChildForSiteViewerVersion = (childrenArray, siteViewerVersion)=> {
  return find(childrenArray, (child)=> {
    return getSiteViewerVersionFromChild(child) === siteViewerVersion;
  });
};


const SiteViewerVersionComponentSelector = ({ siteViewerVersion, children, ...props })=> {
  const childrenArray = Children.toArray(children);

  var child = getChildForSiteViewerVersion(
    childrenArray,
    siteViewerVersion
  );

  // if we couldn't find a matching child then we can assume that the maximum
  // siteViewerVersion found is the correct component to choose. in the future
  // we may want to introduce a new version of a specific component without
  // building a new version of every other component. this strategy allows us
  // to effectively always get the latest component available.
  if (isNil(child)) {
    child = getChildForSiteViewerVersion(
      childrenArray,
      max(map(childrenArray, getSiteViewerVersionFromChild))
    );
  }

  // ensure we have chose a single child by this point
  child = Children.only(child);

  // ensure we remove the viewer version prop from this child so the DOM does
  // not get it unexpectedly and throw an error
  const childProps = omit(child.props, [SITE_VIEWER_VERSION_PROP]);
  const filteredChild = { ...child, props: childProps };

  return cloneElement(filteredChild, props);
};

export default SiteViewerVersionComponentSelector;
